export function getCertStatusBadge(value) {
    let badge = 'badge-secondary'
    switch (value) {
      case '0':
        badge = 'badge-dark'
        break
      case '1':
        badge = 'badge-success'
        break
      case '2':
        badge = 'badge-warning'
        break
      default:
        badge = 'badge-secondary'
    }
  
    return badge
  }